import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "size", "validationState", "variant", "disabled", "readonly", "focused", "selectable", "style", "prefix", "postfix", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { extractSupportProps } from '@snack-uikit/utils';
import { VALIDATION_STATE } from '../../constants';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FieldContainerPrivate(_ref) {
  var className = _ref.className,
    children = _ref.children,
    size = _ref.size,
    validationState = _ref.validationState,
    variant = _ref.variant,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    focused = _ref.focused,
    selectable = _ref.selectable,
    style = _ref.style,
    prefix = _ref.prefix,
    postfix = _ref.postfix,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleContainerClick = function handleContainerClick(event) {
    if (disabled) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn(className, styles.container),
    style: style,
    "data-size": size,
    "data-validation": disabled || readonly ? VALIDATION_STATE.Default : validationState,
    "data-variant": variant,
    "data-disabled": disabled || undefined,
    "data-readonly": readonly || undefined,
    "data-focused": focused || undefined,
    "data-selectable": selectable || undefined,
    "data-test-id": "field-container-private",
    onClick: handleContainerClick,
    role: "textbox",
    tabIndex: -1
  }, extractSupportProps(rest)), {}, {
    children: [prefix && /*#__PURE__*/_jsx("span", {
      className: styles.prefix,
      "data-test-id": "field-container-private__prefix-icon",
      children: prefix
    }), children, postfix && /*#__PURE__*/_jsx("span", {
      className: styles.postfix,
      children: postfix
    })]
  }));
}